module.exports = __webpack_public_path__ + "img/wendu0.gif";